export default __webpack_public_path__ + "static/media/serviceontario.42d01ca2.png";